import { Injectable, Inject } from '@angular/core';
import { Http } from "@angular/http";

@Injectable()
export class ConfigService {
    config: any;
    constructor(private http: Http, @Inject('BASE_URL') private baseUrl: string) {
        console.log('Constructing ConfigService')
    }

    load() {
        console.log('Loading configuration');
        return new Promise<void>((resolve) => {
            this.http.get(this.baseUrl + 'api/config').subscribe(result => {
                this.config = result.json();
                this.config.redirectUri = window.location.protocol + "//" + window.location.host + "/login";
                this.config.b2cScopes = ["openid", "profile", this.config.islandReadScope];
                // "offline_access" removed
                // offline_access: will ensure a refresh_token is returned, which can be used to get a new access token later.                
                // Details: https://docs.microsoft.com/en-us/azure/active-directory-b2c/active-directory-b2c-access-tokens#requesting-a-token
                // Unfortunately it just causes a pop-up to relogin.
                // Probably related to: https://github.com/Azure-Samples/active-directory-b2c-javascript-msal-singlepageapp/issues/17
                resolve();
            }, error => console.error(error));
        });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/_shared/services/config.service.ts